import interceptors from "./interceptors/index";

const fetchPromotions = (format, local, limit) => {
  const params = { p_formato: format, p_local: local };
  if (limit) params["limit"] = limit;
  return interceptors({
    url: "/online-promocional/promotions",
    method: "GET",
    params,
  });
};

const downloadBinary = (promotionIds) => {
  return interceptors({
    url: "/online-promocional/download",
    responseType: 'arraybuffer',
    headers: {
      'Accept': 'application/octet-stream'
    },
    method: "POST",
    data: { promotionIds },
  });
};

const uploadFile = (file) => {
  return interceptors({
    url: "/online-promocional/upload-file",
    method: "POST",
    data: file,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export { fetchPromotions, downloadBinary, uploadFile };
